// v2.18.2 (production 2026-10-25): an operator pressed Mulai and "nothing happened" — the refusal was
// shown only at the top of the page (out of view) with a general sentence, and the list was not
// reloaded. Now the reason from the server is shown under the row's buttons. Pure helpers (no imports)
// so Jest can test them; the server decides everything.

const UMUM = {
  400: "Perubahan status tidak valid.",
  401: "Silakan login kembali.",
  403: "Anda tidak memiliki akses ke pekerjaan ini.",
  404: "Data pekerjaan tidak ditemukan.",
  409: "Pekerjaan sudah dikerjakan atau statusnya telah berubah.",
};

// The server's own message first (plain Indonesian, no internal details), else a general sentence.
// `format` = formatApiErrorDetail for validation lists (422).
export function pesanGagal(e, format) {
  const res = e && e.response;
  if (!res) {
    return e && e.code === "ECONNABORTED"
      ? "Server tidak menjawab. Periksa internet, lalu tekan Refresh dan coba lagi."
      : "Tidak tersambung ke server. Periksa internet, lalu coba lagi.";
  }
  const d = res.data && res.data.detail;
  if (typeof d === "string" && d.trim()) return d.trim();
  if (d && format) {
    const t = format(d);
    if (t) return t;
  }
  return UMUM[res.status] || `Gagal (kode ${res.status}). Tekan Refresh lalu coba lagi; bila tetap gagal, hubungi Owner.`;
}

// one queue row (a step of an SPK, or a tailor's part)
export function kunciGalat(q) {
  return `${q.spk_id}|${q.instance_id}|${q.urutan}|${q.bagian_id || ""}`;
}

// v2.18.2 (production 2026-10-25: 9 Mulai accepted in 25 s, the operator saw no change): the started row
// changes at once, before the list comes back; the reload then replaces it with the server's data
export function tandaiDimulai(rows, q, username, waktu) {
  const k = kunciGalat(q);
  return rows.map((r) => (kunciGalat(r) === k ? { ...r, status: "IN_PROGRESS", started_by_username: username, started_at: waktu } : r));
}

// Selesai appears where Mulai was: a second click right after Mulai must not finish the work
export const JEDA_SELESAI_MS = 5000;
